import { toast } from "react-toastify";
import { handleError } from "../../../utils/helpers";
import { baseApi } from "../../api";
import {
  AddAdminPayload,
  AddAdminResponse,
} from "./addAdminTypes";
import {
  AdminTwoFaPayload,
  RegenerateBackUpCodeResponse,
} from "./auth/auth.types";

export const addAdminApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    addAdmin: builder.mutation<AddAdminResponse, AddAdminPayload>({
      query: (payload) => {
        return {
          url: "admin/signup",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Admin added");
        } catch (err) {
          handleError(err);
        }
      },
    }),
    regenerateBackupCodes: builder.mutation<
      RegenerateBackUpCodeResponse,
      AdminTwoFaPayload
    >({
      query: (payload) => {
        return {
          url: "admin/generate-backup-otp",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const {
  useAddAdminMutation,
  useRegenerateBackupCodesMutation,
} = addAdminApi;
